module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Relatório para seguro"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Alunos",
      "value": 1
    },
    model: {
      value: (_vm.relatorio.tipo),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "tipo", $$v)
      },
      expression: "relatorio.tipo"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Externos",
      "value": 2
    },
    model: {
      value: (_vm.relatorio.tipo),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "tipo", $$v)
      },
      expression: "relatorio.tipo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": "Data de início",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.relatorio.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "dataInicial", $$v)
      },
      expression: "relatorio.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": "Data de conclusão",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.relatorio.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "dataFinal", $$v)
      },
      expression: "relatorio.dataFinal"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.baixar()
      }
    }
  }, [_vm._v("Baixar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7cd8d14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/relatorio-seguro.vue
// module id = 732
// module chunks = 0